import React from 'react';
import { Link } from 'react-router-dom';
import { FiChevronDown, FiGlobe, FiShield } from 'react-icons/fi';
import { useAuth } from './AuthContext';
import { useLanguage } from '../i18n/LanguageContext';
import './Navbar.css';

function Navbar() {
  const { user, logout, loginPatient, loginProfessional, signupPatient } = useAuth();
  const { language, setLanguage, t, translateContent } = useLanguage();

  const getDashboardPath = (userType) => {
    switch (userType) {
      case 'admin':
        return '/admin/dashboard';
      case 'professional':
        return '/professional/dashboard';
      case 'patient':
        return '/patient/dashboard';
      default:
        return '/';
    }
  };

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'fr' : 'en');
  };

  const utilityLabel = user
    ? user.user_type === 'professional'
      ? t('nav.providerArea')
      : t('nav.clientArea')
    : t('nav.clientArea');

  return (
    <header className="km-nav">
      <div className="km-nav__utility">
        <div className="km-page-shell km-nav__utility-inner">
          <div className="km-nav__trust">
            <FiShield />
            <span>{language === 'fr' ? 'Plateforme de soins coordonnés et vérifiés' : 'Verified coordinated care platform'}</span>
          </div>
          <div className="km-nav__utility-actions">
            {user ? (
              <Link className="km-nav__utility-link" to={getDashboardPath(user?.user_type)}>
                {utilityLabel}
              </Link>
            ) : (
              <>
                <button className="km-nav__utility-link" type="button" onClick={() => loginPatient()}>
                  {t('nav.clientArea')}
                </button>
                <button className="km-nav__utility-link" type="button" onClick={() => loginProfessional()}>
                  {t('nav.providerArea')}
                </button>
              </>
            )}
            <button className="km-nav__utility-link km-nav__lang-toggle" type="button" onClick={toggleLanguage}>
              <FiGlobe />
              <span>{t('nav.languageSwitch')}</span>
            </button>
          </div>
        </div>
      </div>

      <div className="km-page-shell">
        <nav className="km-nav__bar" aria-label="Primary">
          <Link className="km-nav__brand" to="/">
            <span className="km-nav__brand-wordmark">KnowMediQ</span>
          </Link>

          <div className="km-nav__links">
            <Link className="km-nav__link" to="/booking">
              {language === 'fr' ? 'Trouver des soins' : 'Find care'}
            </Link>

            <div className="km-nav__dropdown">
              <Link className="km-nav__link km-nav__link--dropdown" to="/booking">
                <span>{language === 'fr' ? 'Comment ça marche' : 'How it works'}</span>
                <FiChevronDown />
              </Link>
              <div className="km-nav__dropdown-panel">
                <Link to="/services/soins-a-domicile">{translateContent('Soins à domicile')}</Link>
                <Link to="/services/sante-mentale">{translateContent('Santé mentale')}</Link>
                <Link to="/services/bien-etre">{translateContent('Bien-être')}</Link>
                <Link to="/services/analyses-de-sang">{translateContent('Analyses de sang')}</Link>
                <Link to="/services/livraison-de-medicaments">{translateContent('Livraison de médicaments')}</Link>
              </div>
            </div>

            <Link className="km-nav__link" to="/booking">
              {language === 'fr' ? 'Solutions IA' : 'AI solutions'}
            </Link>

            <Link className="km-nav__link" to="/blog">
              {t('nav.blog')}
            </Link>

            <Link className="km-nav__link" to="/contact">
              {t('nav.contact')}
            </Link>
          </div>

          <div className="km-nav__actions">
            {user ? (
              <>
                <Link className="km-button-secondary km-nav__action-secondary" to={getDashboardPath(user?.user_type)}>
                  {user.user_type === 'professional' ? t('nav.providerArea') : t('nav.clientArea')}
                </Link>
                <button className="km-button km-nav__action-primary" type="button" onClick={logout}>
                  {t('nav.logout')}
                </button>
              </>
            ) : (
              <>
                <button className="km-button-secondary km-nav__action-secondary" type="button" onClick={() => signupPatient()}>
                  {language === 'fr' ? 'Commencer' : 'Get started'}
                </button>
                <button className="km-button km-nav__action-primary" type="button" onClick={() => loginProfessional()}>
                  {t('nav.providerArea')}
                </button>
              </>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
